// extracted by mini-css-extract-plugin
export default {"container":"InfoTemplateView_container__XcWqH","innerContainer":"InfoTemplateView_innerContainer__zri5a","paper":"InfoTemplateView_paper__ohnAo"};